<template>
  <div>
    <router-view></router-view>
    <loading-animation v-if="loading"></loading-animation>
  </div>
</template>

<script>
import { LoadingAnimation } from '@/components';
// import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
// import SettingsLayout from "@/pages/Layout/SettingsLayout.vue";
// import ProfileUpdate from "@/pages/ProfileUpdate.vue";
// import Businesses from "@/pages/Businesses.vue";

// import AuthGuard from "@/guards/auth.guard";

import http from '@/utils/Http.util';
import { getRoutes } from '@/utils/Acl.util';

import { sidemenu } from './config';

export default {
  components: {
    LoadingAnimation,
  },
  created() {
    this.loadMenu();
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  data() {
    return {
      activeBusiness: this.$store.state.activeBusiness,
      businesses: [],
      menu: [],
      profile: [],
      settings: [],
      sync: false,
    };
  },

  methods: {
    getRoutes,
    loadMenu() {
      this.menu = this.getRoutes(sidemenu);

      // const childRoutes = [];

      // this.menu.forEach((item, index) => {
      //   if (item.path === "/settings") {
      //     childRoutes.push({
      //       path: item.path,
      //       component: SettingsLayout,
      //       name: item.label,
      //       children: settingsRoutes,
      //       beforeEnter: AuthGuard.isAuthorizedRoute,
      //       meta: {
      //         key: index,
      //         title: item.label,
      //         resources: item.meta.resources,
      //         requireAuth: item.meta.requireAuth,
      //       },
      //     });
      //   } else {
      //     childRoutes.push({
      //       path: item.path,
      //       component: item.component,
      //       name: item.label,
      //       beforeEnter: AuthGuard.isAuthorizedRoute,
      //       meta: {
      //         key: index,
      //         title: item.label,
      //         resources: item.meta.resources,
      //         requireAuth: item.meta.requireAuth,
      //       },
      //     });
      //   }
      // });

      // this.$router.addRoutes([
      //   {
      //     path: "/profile",
      //     // name: "Profile",
      //     component: DashboardLayout,
      //     children: [
      //       {
      //         path: "",
      //         component: ProfileUpdate,
      //         name: "Profile",
      //         beforeEnter: AuthGuard.isAuthenticatedRoute,
      //       },
      //       {
      //         path: "businesses",
      //         component: Businesses,
      //         name: "Switch Business",
      //         beforeEnter: AuthGuard.isAuthenticatedRoute,
      //       },
      //     ],
      //   },
      //   {
      //     path: "/",
      //     component: DashboardLayout,
      //     beforeEnter: AuthGuard.isAuthenticatedRoute,
      //     children: childRoutes,
      //   },
      //   {
      //     path: "*",
      //     redirect: `/`,
      //   },
      // ]);
    },

    async updateActiveBusiness(businessId) {
      this.$store.commit('busyStatus', true);
      try {
        await http.authReq(
          '/dashboard/me/business-accesses/active',
          { business_id: businessId },
          'put',
        );

        this.activeBusiness = await this.getActiveBusiness();
        this.loadMenu();
        this.$router.replace('/');

        this.$store.commit('busyStatus', false);
      } catch (err) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
      }
    },

    async getBusinesses() {
      return http.authReq('/dashboard/me/business-accesses').then((result) => {
        this.$store.commit('busyStatus', false);
        const { data } = result;

        return data.map((item) => item.business);
      });
    },

    async getActiveBusiness() {
      this.$store.commit('busyStatus', true);
      try {
        const result = await http.authReq('/dashboard/me/business-accesses/active');
        const { data } = result;

        if (!data) {
          this.$router.replace('/businesses');
        } else {
          this.$store.commit('setAcl', data.acl);
          this.$store.commit('setActiveBusiness', {});
          this.$store.commit('setActiveBusiness', data.business.business);
        }
        this.$store.commit('busyStatus', false);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: 'Unable to get active business',
        };
        this.$store.commit('busyStatus', false);
      }
    },
  },
};
</script>

<style>
md-datepicker {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

md-datepicker * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.md-datepicker-header {
  background-color: #4ea852 !important;
}

.md-datepicker-selected {
  background-color: #4ea852 !important;
}

.md-datepicker-dialog.md-theme-default
  .md-datepicker-month-button.md-datepicker-selected,
.md-datepicker-dialog.md-theme-default
  .md-datepicker-year-button.md-datepicker-selected {
  color: white !important;
}

@media (max-width: 600px) {
  .md-datepicker-dialog {
    top: 20% !important;
  }
}
</style>
